import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React, { useCallback } from "react";
import { UseFormSetError } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SkillsFrameworkData } from "../skills_frameworks.types";
import { SkillsFrameworksEditPage } from "./skills_frameworks_edit_page";
import { useSkillsFrameworksEditPage } from "./use_skills_frameworks_edit_page";
import { useInitialValues } from "./utils/use_initial_values";

type SkillsFrameworksEditControllerProps = {
  isNew?: boolean;
};

export const SkillsFrameworksEditController = ({
  isNew = false
}: SkillsFrameworksEditControllerProps): JSX.Element => {
  const { t } = useTranslation(["skillsFrameworks", "translation"]);
  const {
    skillsFramework,
    isFetching,
    isCreating,
    isUpdating,
    fetchError,
    handleSkillsFrameworkCreate,
    handleSkillsFrameworkUpdate
  } = useSkillsFrameworksEditPage();

  const initialValues = useInitialValues({ isNew, skillsFramework });

  const handleSubmit = useCallback(
    (formValues: SkillsFrameworkData, setError: UseFormSetError<SkillsFrameworkData>) => {
      if (isNew) {
        handleSkillsFrameworkCreate(formValues, setError);
      } else {
        handleSkillsFrameworkUpdate(formValues, setError);
      }
    },
    [handleSkillsFrameworkCreate, handleSkillsFrameworkUpdate, isNew]
  );

  const WrappedSkillsFrameworksEditPage = usePageWrapper(SkillsFrameworksEditPage);

  return (
    <WrappedSkillsFrameworksEditPage
      loading={isFetching}
      errors={fetchError ? [fetchError] : []}
      fade={isCreating || isUpdating}
      errorComponent={
        <NotFoundComponent
          message={t("skillsFrameworks:edit.errors.notFoundMessage")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/admin/skills_frameworks"
        />
      }
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};
